(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["apps"] && !Shopify.designMode) return;
  try {
    
const sections = document.querySelectorAll('.custom-app-section');

const observer = new IntersectionObserver(
  (entries) => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;

      const section = entry.target;
      
      if (section.dataset.loaded === 'true') continue;
      section.dataset.loaded = 'true';

      const sectionId = section.id.replace('shopify-section-', '');
      const url = `${window.location.pathname}?section_id=${encodeURIComponent(sectionId)}&view=custom-loading`;

      // Substituição do XMLHttpRequest por fetch
      fetch(url)
        .then(response => {
          if (!response.ok) {
            throw new Error(`status ${response.status}`);
          } 
          return response.text();
        })
        .then(html => {
          // 1. Injeta o conteúdo inicial (invisível por causa do CSS anterior)
          section.innerHTML = `<div class="app-content-wrapper">${html}</div>`;
          const wrapper = section.querySelector('.app-content-wrapper');

          // 2. RESSUSCITAR SCRIPTS: Copia e recria os scripts para forçar a execução
          const scripts = wrapper.querySelectorAll('script');
          scripts.forEach((oldScript) => {
            const newScript = document.createElement('script');
            // Copia todos os atributos (src, type, async, etc)
            Array.from(oldScript.attributes).forEach((attr) => {
              newScript.setAttribute(attr.name, attr.value);
            });
            // Copia o conteúdo interno do script, se houver
            newScript.appendChild(document.createTextNode(oldScript.innerHTML));
            // Substitui o script morto pelo novo script executável
            oldScript.parentNode.replaceChild(newScript, oldScript);
          });

          // 3. FUNÇÃO DE REVELAÇÃO
          let isRevealed = false;
          const revealSection = () => {
            if (isRevealed) return;
            isRevealed = true;
            section.classList.add('is-fully-loaded');
            domObserver.disconnect(); // Para de observar o DOM
            observer.unobserve(section); // Para de observar o scroll
          };

          // 4. OBSERVAR O APP INJETANDO ELEMENTOS
          const domObserver = new MutationObserver((mutations) => {
            for (const mutation of mutations) {
              // Se o script do app adicionou novos nós (elementos) no DOM
              if (mutation.addedNodes.length > 0) {
                // Dá 300ms de folga para o app terminar de montar o layout e revela
                // Nota: O comentário original diz 300ms, mas o código diz 1000ms. Mantive 1000ms.
                setTimeout(revealSection, 1000);
                break;
              }
            }
          });

          // Configura o observador para olhar filhos e sub-filhos do wrapper
          domObserver.observe(wrapper, { childList: true, subtree: true });

          // 5. FALLBACK DE SEGURANÇA
          // Se o app quebrar ou não injetar nada em 4 segundos, revela a section de qualquer jeito
          setTimeout(revealSection, 4000);
          // Dispara o evento manualmente. 
          // O código do Instafeed vai ouvir isso, achar que a página acabou de carregar, e rodar.
          window.document.dispatchEvent(new Event('DOMContentLoaded', {
            bubbles: true,
            cancelable: true
          }));
        })
        .catch(error => {
          console.error(`Erro na requisição ou rede no lazy load da section: ${error.message}`);
          delete section.dataset.loaded;
        });
    }
  },
  {
    threshold: 0.1
  }
);

sections.forEach((section) => {
  observer.observe(section);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      const headerElm = this.header.querySelector('header');
      document.documentElement.style.setProperty('--header-height', `${headerElm.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (document.querySelector('.header__search details[open="true"]')) return;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
